
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistics",
      function () {
        return require("private-next-pages/statistics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistics"])
      });
    }
  